<script setup lang="ts">
// import SvgoCheckmark from "~ui/assets/icons/checkmark.svg?skipsvgo"
const { video, category, referrer, placement } = defineProps<{
  video: {
    image?: string
    duration: number
    title: string
    id: string
  }
  category?: string
  referrer?: string
  placement?: string
}>()
const { session } = useAuth()
const { videosRestricted } = useTrainingRestrictions()
const isWatched = computed(() =>
  session.value?.watched_videos?.includes(video.id),
)

const wrapperComponent = computed(() => {
  return category && !isLocked.value ? resolveComponent("NuxtLink") : "button"
})
const wrapperProps = computed(() => {
  return category && !isLocked.value
    ? {
        to: {
          name: "videos-category-video-id",
          params: {
            category: camelToKebab(category),
            id: video.id,
          },
          query: { referrer, placement },
        },
      }
    : undefined
})

const { data: mandatoryContent } = await useCachedFetch<Mandatory>(
  "/mandatory/data",
  { method: "post", lazy: true, dedupe: "defer" },
)

const isMandatory = computed(() => {
  return Boolean(
    mandatoryContent.value?.videos.find(
      (mandatoryVideo) => mandatoryVideo.content.id == video.id,
    ),
  )
})

const isLocked = computed(() => {
  return videosRestricted.value && !isMandatory.value
})
</script>
<template>
  <component :is="wrapperComponent" v-bind="wrapperProps">
    <LayoutCard
      :gutter="false"
      class="group mb-0! h-full overflow-hidden text-left"
      :class="isLocked && 'cursor-not-allowed opacity-60'"
    >
      <div
        class="transition-duration-300 relative w-full overflow-hidden bg-zinc-200 pb-[56.15%] transition-opacity"
        :class="!isLocked && 'group-hover:opacity-85'"
      >
        <img
          :src="video.image ?? '/img/placeholder.jpg'"
          class="absolute top-0 left-0 h-auto w-full max-w-full rounded-t-lg transition-all"
          :alt="video.title"
        />
        <div class="absolute top-0 left-0 w-full pb-[56.15%] drop-shadow-xs" />
        <VideoDuration :duration="video.duration" />

        <div v-if="isLocked" class="absolute top-2 right-2">
          <TrainingRestrictionTooltip training-type="video">
            <div class="rounded-full bg-white/90 p-0.5">
              <SvgoPikaLock class="size-4 text-zinc-700" />
            </div>
          </TrainingRestrictionTooltip>
        </div>
        <Badge
          v-else-if="isWatched && isMandatory"
          class="absolute top-1 right-1 flex flex-row items-center justify-start"
        >
          <template #icon><SvgoPikaRefresh /></template>
          {{ $t("mandatory.retake") }}
        </Badge>
        <Checkmark
          v-else-if="isWatched"
          class="absolute top-2 right-2 h-5 w-5 flex-none"
        />
      </div>
      <div class="px-4 py-2">
        <div data-testid="videocard_title" class="font-medium text-zinc-700">
          {{ video.title }}
        </div>
      </div>
    </LayoutCard>
  </component>
</template>
